import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { Layout } from './components/Layout';
import { config } from './config';
import { I18nProvider } from './i18n';
import { CallbackPage } from './pages/CallbackPage';
import { GamePage } from './pages/GamePage';
import { HomePage } from './pages/HomePage';
import { MePage } from './pages/MePage';

export function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter basename={config.basePath === '/' ? undefined : config.basePath}>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/games/:gameKey" element={<GamePage />} />
              {/* C03 §3：這是 gaming-portal-web 唯一的 redirect URI */}
              <Route path="/auth/callback" element={<CallbackPage />} />
              <Route path="/me" element={<MePage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
